module.exports = __webpack_public_path__ + "static/img/wechatApp.b4f822b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wechatApp.jpg
// module id = I6I5
// module chunks = 1